import styled from 'styled-components';

const PaperContainer = styled.div`
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
`;

export default PaperContainer;
